import React from "react";
import "./Evenement.scss";

function Evenement() {
  return <div className="evenement">
  </div>
}

export default Evenement;
